<template lang="pug">
  div
    v-dialog(v-model='notificationDialog' width='60%' @click:outside='closeNotificationDialog')
      v-toolbar.toolbar-settings.text-settings(style='z-index: 99999')
        span(style='font-size: 1.125rem; line-height: 1.4em; font-weight: 300; font-size: 18px;') {{`ID : ${itemId}`}}
        v-spacer
        v-btn#closeIcon(icon color='white' @click='closeNotificationDialog')
          md-icon close
      v-card(style='max-width: 100%; padding-bottom: 35px;')
        v-card-text.content-dialog
          v-form(ref="sendTemplate").pa-0.pt-10
            p.title-message {{$t('campaign.templateData')}}
            v-skeleton-loader(v-if='templateIsLoading' #dark style='width: 50%;' type="text@1")
            p.subitem(v-if='!templateIsLoading') {{$t('campaign.sender')}}: {{ ' ' }}
              span {{generateSenderLabel()}}
            v-skeleton-loader(v-if='templateIsLoading' #dark style='width: 50%;' type="text@1")
            p.subitem(v-if='!templateIsLoading') {{$t("commonWords.channel")}}: {{ " " }}
              span {{generateChannelsLabel()}}
            v-skeleton-loader(v-if='templateIsLoading' #dark style='width: 50%;' type="text@1")
            p.subitem(v-if='!templateIsLoading') {{$t("campaign.templateName")}}: {{ " " }}
              span {{template.name}}
            v-skeleton-loader(v-if='templateIsLoading' #dark type="image" style='width: 50%;')
            p.subitem(v-if='!templateIsLoading') {{$t("campaign.templateText")}}
            TextEditor.text-editor(ref="texEditor" :value="textMessage" disabled theme="bubble" v-if='!templateIsLoading')
            .quick-replies-buttons.mb-6
              .d-flex.flex-wrap(v-if="!verifyIfChannelIsActive('sms') && template.messageOptions && template.messageOptions.options.quick_replies.length > 0")
                v-btn(
                  v-for="quickReply in template.messageOptions.options.quick_replies"
                  :key="quickReply.content"
                  disabled
                ) {{quickReply.title}}
            p.title-params {{$t("templates.inputTestData")}}
            v-skeleton-loader(v-if='templateIsLoading' type="image" style='height: 56px;')
            VPhone.mr-3(
              v-if="(verifyIfChannelIsActive('sms') || verifyIfChannelIsActive('whatsapp')) && !templateIsLoading"
              :placeholder="$t('chatHistoyFilter.phoneNumber')"
              :value='phone'
              label="(xx)XXXXX-XXXX"
              :rules="[rules.required]"
              @input='updatePhoneNumber($event)')
            v-text-field(
              v-if="verifyIfChannelIsActive('teams') && !templateIsLoading"
              :label="$t('commonWords.email')"
              placeholder="usuario@email.com"
              v-model="email"
              filled
              :rules="[rules.required, rules.mustHaveAt]"
              dense
              required
            )
            div(v-if="templateFields.length > 0" )
              .d-flex.justify-space-between.align-center(v-for="field in templateFields")
                v-text-field(
                  v-model="templateFieldValues[field]"
                  :label="generatePlaceholder(field)"
                  :rules="[rules.required]"
                  filled
                  dense
                  required
                )
            .d-flex.justify-space-between.align-center
              md-switch(v-model="hideSensitiveContent"  )
                span {{$t('testNotificationDialog.hideSensitiveContent')}}
              span {{hideSensitiveContent ? $t('commonWords.enabled') : $t('commonWords.disabled')}}
        v-card-actions.text-right
          v-btn(@click='closeNotificationDialog' text color="#3B3B3B" style='margin-right: 10px') {{$t('templates.cancel')}}
          v-btn(@click='sendNotification' :disabled="!allowedToSave" :loading="loading" color='#43a047'
            style='color:white;')  {{$t('commonWords.send')}}
    SimpleModal(
      maxWidth='440px'
      :show-modal="sendNotificationModal"
      :show-r-button="wasItSuccessful"
      :show-l-button="wasItSuccessful"
      lButtonColor="#3B3B3B"
      rButtonColor="#43a047"
      :l-button-as-text="true"
      @clickLButton="closeNotificationDialog"
      @clickRButton="resetFields"
      button-area-padding="30px 12px"
      :l-button-title="$t('templates.close')"
      :r-button-title="$t('templates.sendToNextRecipient')"
      )
      template(slot='content')
        .d-flex.flex-column.align-center.justify-center(v-if="wasItSuccessful")
          check-circle.icon-size
          span.statusModalTitle {{$t('templates.sendSuccessfully')}}
        .d-flex.flex-column.align-center.justify-center(v-else)
          error-circle.icon-size
          span.statusModalTitle {{$t('commonWords.error')}}
          span.statusModalTitle {{errorMessage}}
</template>

<script>
import Swal from 'sweetalert2'
import TextEditor from '@/components/TextEditor.vue'
import VPhone from '@/components/VPhone.vue'
import SimpleModal from '@/components/Reuse/SimpleModal.vue'
import checkCircle from '@/assets/img/check-circle.svg'
import errorCircle from '@/assets/img/error-circle.svg'

export default {
  components: { SimpleModal, VPhone, TextEditor, checkCircle, errorCircle },
  props: {
    notificationDialog: {
      type: Boolean
    },
    itemId: {
      type: String
    },
    channelSettings: {
      type: Object
    }
  },
  data () {
    return {
      templateIsLoading: false,
      templateFields: [],
      templateData: {},
      textMessage: '',
      loading: false,
      template: {},
      sender: '',
      phone: '',
      email: '',
      activeChannels: [],
      templateFieldValues: {},
      hideSensitiveContent: false,
      sendNotificationModal: false,
      wasItSuccessful: false,
      errorMessage: '',
      rules: {
        required: v => !!v || this.$t('commonPhrases.requiredField'),
        mustHaveAt: v => v.includes('@') || this.$t('templates.mustContainAt')
      }
    }
  },
  async created () {
    this.templateIsLoading = true
    this.wasItSuccessful = false

    if (this.itemId) {
      await this.getTemplateData(this.itemId)
      this.templateIsLoading = false
    }
  },
  computed: {
    allowedToSave () {
      const doesItContainsSmsOrWhatsapp = this.activeChannels.some(channel => channel.name.toLowerCase() === 'sms' || channel.name.toLowerCase() === 'whatsapp')
      const doestItContainsTeams = this.activeChannels.some(channel => channel.name.toLowerCase() === 'teams')
      const emptyDynamicFields = this.templateFields.map((field) => this.templateFieldValues[field]).some((value) => value === '')

      if (emptyDynamicFields) {
        return false
      }

      if (doesItContainsSmsOrWhatsapp) {
        return this.phone !== ''
      }

      if (doestItContainsTeams) {
        if (this.email) {
          return this.email.includes('@')
        }
        return false
      }

      return true
    }
  },
  methods: {
    resetFields () {
      this.sendNotificationModal = false
      this.phone = ''
      this.email = ''
      this.loading = false

      this.templateFields.forEach((field) => {
        this.$set(this.templateFieldValues, field, '')
      })
    },
    generatePlaceholder (val) {
      return `${this.$t('templates.parameter')} ${val}`
    },
    generateChannelsLabel () {
      return this.activeChannels.filter(channel => channel.name.toLowerCase() !==
        'instagram').map(channel => channel.name).join(', ')
    },
    generateSenderLabel () {
      return this.activeChannels.filter(channel => channel.name).map(channel => {
        if (channel.name.toLowerCase() === 'teams') {
          return this?.channelSettings?.fromTeams
        }
        if (channel.name.toLowerCase() === 'whatsapp') {
          return this?.channelSettings?.fromWhatsapp
        }
        if (channel.name.toLowerCase() === 'sms') {
          return this?.channelSettings?.fromSMS
        }
      }).join(', ')
    },
    updatePhoneNumber (value) {
      this.phone = value
    },
    async getTemplateData (id) {
      try {
        await this.$axios.get(`${process.env.VUE_APP_BACKEND_BASE_URL}/message-templates/${id}`).then(response => {
          this.template = response.data._source
          this.textMessage = response.data._source.messageOptions.text[0]
          this.activeChannels = response.data._source.channels.filter(channel => channel.isActive)

          this.templateFields = this.textMessage?.match(/(?<={{)(.*?)(?=}})/g) ?? []
          this.templateFields.forEach((field) => {
            this.$set(this.templateFieldValues, field, '')
          })
        })
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: this.$t('testNotificationDialog.thereWasAnErrorInYourRequest')
        })
      }
    },
    closeNotificationDialog () {
      this.template = {}
      this.loading = false
      this.sendNotificationModal = false
      this.$emit('closeNotification')
    },
    verifyIfChannelIsActive (channelToVerify) {
      return this.activeChannels.some(channel => channel.name.toLowerCase() === channelToVerify)
    },
    async sendNotification () {
      const isRefsValid = this.$refs.sendTemplate.validate()
      if (isRefsValid) {
        try {
          const payload = {
            contacts: [],
            templateId: this.itemId,
            hideSensitiveContent: this.hideSensitiveContent,
            messageOptions: [],
            waitStatus: true
          }
          this.activeChannels.forEach(channel => {
            if (channel.name === 'teams') {
              payload.contacts.push({
                channel: channel.name,
                from: this?.channelSettings?.fromTeams,
                to: this.email
              })
            } else if (channel.name === 'whatsapp') {
              payload.contacts.push({
                channel: channel.name,
                from: this.channelSettings.fromWhatsapp,
                to: this.phone
              })
            } else if (channel.name === 'sms') {
              payload.contacts.push({
                channel: channel.name,
                from: this.channelSettings.fromSMS,
                to: this.phone
              })
            }
          })
          this.templateFields.forEach((field) => {
            payload.messageOptions.push({
              [field]: this.templateFieldValues[field]
            })
          })
          this.loading = true
          await this.$axios.post('/message-notifications', { ...payload })
          this.sendNotificationModal = true
          this.wasItSuccessful = true
          this.loading = false
        } catch (error) {
          this.sendNotificationModal = false
          this.loading = false
          this.wasItSuccessful = false
          this.errorMessage = error?.message
          Swal.fire({
            icon: 'error',
            title: this.$t('testNotificationDialog.thereWasAnErrorInYourRequest')
          })
        }
      }
    }
  },
  watch: {
    channelSettings () {
      this.activeChannels = this.activeChannels.map((channel) => {
        if (channel.name.toLowerCase() === 'teams') {
          channel.from = this?.channelSettings?.fromTeams
        }
        if (channel?.name.toLowerCase() === 'whatsapp') {
          channel.from = this?.channelSettings?.fromWhatsapp
        }
        if (channel?.name.toLowerCase() === 'sms') {
          channel.from = this?.channelSettings?.fromSMS
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
//.content-dialog {
//  //padding: 10px 30px !important;
//}

.icon-size {
  width: 78px;
  height: 78px;
}

.title-params,
.title-message {
  font-size: 22px !important;
  line-height: 26px;
  color: #181818;
  margin-bottom: 20px;
}

.subitem {
  margin-bottom: 10px;
}

.v-text-field {

  &.v-input--is-focused {
    ::v-deep fieldset {
      border: none;
    }
  }

  ::v-deep fieldset {
    border: none;
  }
}

.md-switch {
  ::v-deep .md-switch-label {
    color: rgba(0, 0, 0, .6);
  }
}

.statusModalTitle {
  font-size: 24px;
  line-height: 28px;
  color: #3B3B3B;
  padding-bottom: 10px;
}

.text-editor {
  margin-top: 5px;

  & ::v-deep .quill-editor .ql-container {
    background-color: transparent !important;
    border: 0 !important;

    & .ql-editor {
      padding: 0 !important;
    }
  }
}

.v-select {
  ::v-deep label {
    color: #949494;
  }
}

.md-button {
  background-color: #ff9800 !important;

  &:active,
  &:focus,
  &:active:focus,
  &:hover {
    background-color: #ff9800 !important;
  }

  ::v-deep .md-ripple {
    padding: 12px 30px 12px 15px !important;
  }

  .v-icon,
  .v-icon:hover,
  span:hover,
  span {
    color: black !important;
  }

  &.dashed-button,
  &.dashed-button:hover {
    background-color: white !important;
    border: 2px dashed #F19D38;
    color: #F19D38 !important;

    .v-icon,
    span {
      color: #F19D38 !important;
    }
  }
}

.v-card__actions {
  width: 100%;
}
</style>
